$shm_agent_message_card $mol_card
	role_key \
	role \
	time \
	text \
	header_extra /$mol_view
	content /$mol_view
	Copy_icon $mol_icon_content_copy
	theme <= message_theme \
	attr *
		^
		role <= role_key
	sub /
		<= Head $mol_view
			sub /
				<= Role $mol_paragraph
					title <= role
				<= Header_extra $mol_view
					sub <= header_extra
				<= Copy $shm_button_copy
					hint \Копировать сообщение
					text <= text
					button_sub / <= Copy_icon
				<= Time $mol_paragraph
					title <= time
		<= Content $mol_view
			sub <= content
